import React from 'react';

export default class IndexTableHeading extends React.Component {
    render() {
        return (
            <th onClick={this.props.onClick} slug={this.props.column.slug}
                className={this.props.onClick === undefined ? null : 'sortable ' + (this.props.sortActive ? (this.props.sortDirection === 'descending' ? 'sort--descending' : 'sort--ascending') : '')}>
                <div className="flex-center-v">
                    {this.props.column.name}
                    <span className="index-table-heading-sort-caret"></span>
                </div>
            </th>
        )
    }
}